import { logError } from '@/util/logger';
import type { ltFramework } from '@life-time-inc/enterprise-framework-core';
import type {
	InitRequest,
	InitResponse,
	PostConversationRequest,
	PostFeedbackRequest,
	UserData
} from 'Types/aemui/laic-chat/laicChat';

export class AiService {
	getHeaders(isEventStream = false) {
		const laic = window.lt.api.laic as ltFramework.IDictionary;
		if (!laic?.url || !laic?.key) {
			logError('LAIC config `window.lt.api.laic` is not fully defined', {});
			throw new Error('LAIC config `window.lt.api.laic` is not fully defined');
		}
		const baseURL = `${laic.url}/agents/v1`;
		const headers = new Headers();
		headers.append('Api-Key', laic.key);
		headers.append('Client-Id', 'prospect_site');
		headers.append('Content-Type', 'application/json');
		if (isEventStream) {
			headers.append('Accept', 'text/event-stream');
		}
		return { baseURL, headers };
	}

	async init(request: InitRequest) {
		const { baseURL, headers } = this.getHeaders();
		const response = await fetch(`${baseURL}/init`, {
			method: 'POST',
			headers,
			body: JSON.stringify(request)
		});
		if (!response.ok) {
			const message = await response.text();
			logError('LAIC init ERROR', { status: response.status, message });
			throw new Error(`LAIC init ERROR: ${response.status}: ${message}`);
		}
		const json = (await response.json()) as InitResponse;
		return json;
	}

	async postConversation(request: PostConversationRequest) {
		const { baseURL, headers } = this.getHeaders(true);
		const url = new URL(`${baseURL}/conversation`);
		url.searchParams.append('userId', request.userData.email);
		const response = await fetch(url, {
			method: 'POST',
			headers,
			body: JSON.stringify(request)
		});
		if (!response.ok) {
			const message = await response.text();
			logError('LAIC post conversation ERROR', { status: response.status, message });
			throw new Error(`LAIC post conversation ERROR: ${response.status}: ${message}`);
		}
		return response;
	}

	async postFeedback(userData: UserData, request: PostFeedbackRequest) {
		const { baseURL, headers } = this.getHeaders();
		const url = new URL(`${baseURL}/message-feedback`);
		url.searchParams.append('userId', userData.email);
		const response = await fetch(url, {
			method: 'POST',
			headers,
			body: JSON.stringify(request)
		});
		if (!response.ok) {
			const message = await response.text();
			logError('LAIC post feedback ERROR', { status: response.status, message });
			throw new Error(`LAIC post feedback ERROR: ${response.status}: ${message}`);
		}
		return response;
	}
}

export const aiService = new AiService();
